// extracted by mini-css-extract-plugin
export var messageSideLeft = "_h3-1";
export var messageSideRight = "_h3-2";
export var orderLookupBubbleContainer = "_h3-0";
export var submitButton = "_h3-3";